import React from "react";

const ADO_Add = () => {
  return (
    <div className="tutorial-page">
      <h1>ADO Add</h1>
      <p>This is the ADO Add page content.</p>
    </div>
  );
};

export default ADO_Add;
